import o, { createContext as n, useContext as r } from "react";
const a = n(
  void 0
);
function s() {
  const t = r(a);
  return t || c;
}
function c(t) {
  const e = { ...t };
  return delete e.loader, delete e.blurDataURL, delete e.onLoadingComplete, /* @__PURE__ */ o.createElement("img", { ...e, src: e.src.toString() });
}
export {
  a as I,
  s as u
};
//# sourceMappingURL=ImageContext-57256dc1.mjs.map
